import { render, staticRenderFns } from "./InputFiles.vue?vue&type=template&id=1ad3ecc3&"
import script from "./InputFiles.vue?vue&type=script&lang=js&"
export * from "./InputFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports